// extracted by mini-css-extract-plugin
export default {"listCreateContainer":"ListCreate_listCreateContainer__OAuXv","formWrapper":"ListCreate_formWrapper__yQY1Q"};